import { LegalPage, defaultGovDataRequestContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

export function GovernmentDataRequestPolicy() {
  const content = useCmsContent("government-data-request-policy", defaultGovDataRequestContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <LegalPage content={content} />;
}
